module.exports = __webpack_public_path__ + "img/file-earmark-diff.cda45d17.svg";